import { Icon } from "@material-ui/core";
import { AccountBalance, } from "@material-ui/icons";
import HonariLogoIcon from "../../assets/images/honari_logo.png";

export const MenuItems = [
    {
        title: "داشبورد",
        link: "m",
        Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "تخفیف ها",
        link: "discount",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "چک کردن",
        link: "orders/check",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "درگاه پرداخت",
        link: "gateway",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "پیامک های ارسالی  ",
        link: "sms/send",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "الگو های پیامکی",
        link: "sms/template",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    
        {
        title: "پیامک های ثبت نام",
        link: "sms-limit",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
   
    {
        title: "شماره های بلاک شده ",
        link: "sms-limit/blocked",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: " کلاس های صفحه اصلی",
        link: "homepage/class",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "همگام‌ سازی",
        link: "sync",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "انبارگردانی",
        link: "anbargardani",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "سفارشات",
        link: "orders",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "تغییر آدرس",
        link: "replace_url",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },

    {
        title: "پرسش های متداول",
        link: "list",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "دسته پرسش های متداول",
        link: "faq_cat",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "ارسال های غیر رایگان",
        link: "shipping/index",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "زمانبندی فعالیت های انبار",
        link: "task/time",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    }, {
        title: "تنظیمات rfm",
        link: "rfm/setting",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    }, {
        title: "بنر ها",
        link: "banner",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    }, {
        title: "تنظیمات",
        link: "setting",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    }, {
        title: "مغایرت موجودی محصول",
        link: "conflict/product",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    }, {
        title: "مغایرت موجودی بسته",
        link: "conflict/pack",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    }, {
        title: " بسته های قابل تبدیل",
        link: "convertible",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    }
]


export const MenuReportItems = [
    {
        title: "جستجوی کاربران",
        link: "user_search",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "کرونجاب های ناموفق",
        link: "cronjob/failed",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "کرونجاب های موفق",
        link: "cronjob/success",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "گزارش عملکرد انبار",
        link: "user_reports",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "rfm",
        link: "rfm",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },

    {
        title: "گزارش اکسل",
        link: "excel",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    },
    {
        title: "دریافت گزارش اکسل",
        link: "excel/index",
         Icon: <img
            src={HonariLogoIcon}
            style={{ width: "25px" }}
            className={["mt-2", "mb-2"].join(" ")}
        />
    }, 
]
